import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  iconColor, 
  trend, 
  trendValue,
  currency = false 
}) => {
  const getTrendIcon = () => {
    if (!trend) return null;
    return trend === 'up' ? 'TrendingUp' : 'TrendingDown';
  };

  const getTrendColor = () => {
    if (!trend) return '';
    return trend === 'up' ? 'text-success' : 'text-error';
  };

  return (
    <div className="card hover:elevation-3 transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground font-caption mb-1">
            {title}
          </p>
          <h3 className="text-3xl md:text-4xl font-semibold text-foreground font-heading">
            {currency && 'S/ '}
            {value}
          </h3>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">
              {subtitle}
            </p>
          )}
        </div>
        <div 
          className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon 
            name={icon} 
            size={24} 
            color={iconColor}
          />
        </div>
      </div>
      
      {trend && (
        <div className={`flex items-center space-x-2 ${getTrendColor()}`}>
          <Icon name={getTrendIcon()} size={16} />
          <span className="text-sm font-medium">
            {trendValue}
          </span>
          <span className="text-sm text-muted-foreground">
            vs mes anterior
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;